import React from "react";
import "./TextBoxEntry.css";

interface TextBoxEntryProps {
    header: string;
    subtext: string;
    hintText: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: () => void;
}

const TextBoxEntry: React.FC<TextBoxEntryProps> = ({ header, subtext, hintText, value, onChange, onClick }) => {
    return (
        <div className="textbox-container">
            <h1 className="textbox-header">{header}</h1>
            <p className="textbox-subtext">{subtext}</p>
            <div className="textbox-input-container">
                <input
                    type="text"
                    className="textbox-input"
                    placeholder={hintText}
                    value={value}
                    onChange={onChange}
                />
                <button className="textbox-button" onClick={onClick}>
                    <span role="img" aria-label="search">🔍</span>
                </button>
            </div>
        </div>
    );
};

export default TextBoxEntry;
